import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'User',
    column_type: 'id',
  },
  created_at: {
    model_name: 'User',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'User',
    column_type: 'datetime',
  },
  screen_name: {
    model_name: 'User',
    column_type: 'string',
  },
  is_block: {
    model_name: 'User',
    column_type: 'boolean',
  },
  phone: {
    model_name: 'User',
    column_type: 'string',
  },
  name: {
    model_name: 'User',
    column_type: 'string',
  },
  verification_state: {
    model_name: 'User',
    column_type: 'enum',
  },
  verify_at: {
    model_name: 'User',
    column_type: 'datetime',
  },
  number: {
    model_name: 'User',
    column_type: 'string',
  },
  reject_reason: {
    model_name: 'User',
    column_type: 'text',
  },
  miapay_wallet_holder_attributes: {
    model_name: 'User',
    column_type: 'string',
  },
  can_reset_password: {
    model_name: 'User',
    column_type: 'string',
  },
  can_unlock_red_packet_function: {
    model_name: 'User',
    column_type: 'string',
  },
  balance: {
    model_name: 'User',
    column_type: 'string',
  },
  cashback: {
    model_name: 'User',
    column_type: 'string',
  },
  walk_account: {
    model_name: 'User',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
